<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Vestiging toevoegen</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeAddBranchDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <div class="hogans-alerts">
      <v-alert v-if="feedback" :value="true" type="warning">
        {{ feedback }}
      </v-alert>
    </div>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-form ref="AddBranchForm" lazy-validation>
        <v-expansion-panels accordion v-model="panel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <strong>Adresgegevens</strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              :color="$vuetify.theme.themes[theme].background"
            >
              <v-container grid-list-md fluid class="ma-0 px-0">
                <v-text-field
                  label="Vestigingsnaam"
                  v-model.trim="newBranch.name"
                  prepend-icon="business"
                  :rules="requiredRules"
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  hide-details
                  outlined
                  required
                ></v-text-field>

                <!-- / SALONHUB BRANCH FIELDS \ -->
                <div
                  class="salonhub-branche-fields"
                  v-if="activeCompData.apiItems.salonhub == true"
                >
                  <div class="salonhub-branche-fields-logo"></div>
                  <v-select
                    class="pt-2"
                    v-model="newBranch.branchNameSalonhub"
                    :items="activeCompData.salonhubApiSettings.salons"
                    hint="Welke naam gebruikt Salonhub voor deze vestiging?"
                    item-text="name"
                    item-value="salonhubid"
                    label="Vestigingsnaam Salonhub"
                    persistent-hint
                    outlined
                    dense
                    :color="companyPrimaryColor"
                  ></v-select>
                </div>
                <!-- \ SALONHUB BRANCH FIELDS / -->

                <!-- / DRUPAL BRANCH FIELDS \ -->

                <div
                  class="drupal-branche-fields"
                  v-if="activeCompData.apiItems.drupal == true"
                >
                  <div class="drupal-branche-fields-logo"></div>
                  <v-text-field
                    class="pt-3"
                    label="API url"
                    v-model="newBranch.drupalApiSettings.url"
                    outlined
                    :color="companyPrimaryColor"
                  ></v-text-field>
                  <v-switch
                    class="pa-0 ma-0"
                    :color="companyPrimaryColor"
                    v-model="newBranch.drupalApiSettings.basicAuth"
                    label="Basic HTTP Authentication"
                  >
                  </v-switch>

                  <div
                    class="drupal-basicauth-settings"
                    v-if="newBranch.drupalApiSettings.basicAuth == true"
                  >
                    <v-text-field
                      label="Username"
                      v-model="newBranch.drupalApiSettings.basicAuthUsername"
                      outlined
                      :color="companyPrimaryColor"
                      hide-details
                    ></v-text-field>

                    <v-text-field
                      class="pt-3"
                      label="Password"
                      v-model="newBranch.drupalApiSettings.basicAuthPassword"
                      outlined
                      :color="companyPrimaryColor"
                      hide-details
                    ></v-text-field>
                  </div>
                </div>
                <!-- \ DRUPAL BRANCH FIELDS / -->

                <v-layout row wrap>
                  <v-flex xs12 sm6 md9>
                    <v-text-field
                      class="pt-2"
                      label="Adres"
                      v-model.trim="newBranch.address"
                      prepend-icon="place"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      class="pt-2"
                      label="huisnummer"
                      v-model.trim="newBranch.number"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      class="pt-2"
                      label="Postcode"
                      v-model.trim="newBranch.postalCode"
                      prepend-icon="null"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      :color="companyPrimaryColor"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md9>
                    <v-text-field
                      class="pt-2"
                      label="Plaats"
                      v-model.trim="newBranch.city"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      :color="companyPrimaryColor"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="Provincie"
                      v-model.trim="newBranch.province"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      :color="companyPrimaryColor"
                      outlined
                      hide-details
                      prepend-icon="null"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="Land"
                      v-model.trim="newBranch.country"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      :color="companyPrimaryColor"
                      outlined
                      hide-details
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="Telefoonnummer"
                      v-model="newBranch.phonenumber"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      :color="companyPrimaryColor"
                      outlined
                      hide-details
                      prepend-icon="null"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      class="pt-2"
                      label="E-mailadres"
                      v-model="newBranch.email"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      :color="companyPrimaryColor"
                      hide-details
                      outlined
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>
              <strong>Verzendtijd Review e-mails</strong>
            </v-expansion-panel-header>

            <v-expansion-panel-content
              :color="$vuetify.theme.themes[theme].background"
            >
              <v-container class="pa-0 ma-0">
                <v-layout row wrap>
                  <v-flex xs12 style="padding: 10px 0">
                    <p>
                      Selecteerd de beste tijd zodat de mails na sluiting
                      verzonden worden.
                    </p>
                  </v-flex>

                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Zondag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="newBranch.ECsettings.Sun"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container class="pa-2 mx-0">
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Maandag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="newBranch.ECsettings.Mon"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="
                            $vuetify.theme.themes[theme].background
                          "
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Dinsdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="newBranch.ECsettings.Tue"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container class="pa-2 mx-0">
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Woensdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="newBranch.ECsettings.Wed"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          background-color="$vuetify.theme.themes[theme].background"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Donderdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="newBranch.ECsettings.Thu"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container class="pa-2 mx-0">
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Vrijdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="newBranch.ECsettings.Fri"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          background-color="$vuetify.theme.themes[theme].background"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container
                    class="pa-2 mx-0"
                    :style="{
                      backgroundColor: $vuetify.theme.themes[theme].menu,
                    }"
                  >
                    <v-layout class="ma-0">
                      <v-flex xs6 sm6 md6
                        ><span class="sendTimeLabel">Zaterdag</span></v-flex
                      >
                      <v-flex xs6 sm6 md6>
                        <v-select
                          v-model="newBranch.ECsettings.Sat"
                          :items="surveySendTimes"
                          item-text="name"
                          item-value="value"
                          class="ma-0 pa-0"
                          hide-details
                          outlined
                          dense
                          :color="companyPrimaryColor"
                          :background-color="$vuetify.theme.themes[theme].menu"
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <strong>PDF Bon Footer</strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              :color="$vuetify.theme.themes[theme].background"
            >
              <v-container class="pa-0 ma-0">
                <v-layout row wrap>
                  <v-textarea
                    class="pt-5"
                    label="Footer tekst"
                    v-model="newBranch.receiptData.footer"
                    prepend-icon="notes"
                    required
                    outlined
                    hide-details
                    :color="companyPrimaryColor"
                    :background-color="$vuetify.theme.themes[theme].menu"
                  ></v-textarea>
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeAddBranchDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              v-if="busy == false"
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addBranch()"
            >
              Vestiging toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";

export default {
  name: "add-branch-form",
  props: {
    activeCompData: Object,
  },
  data() {
    return {
      panel: [0],
      newBranch: {
        branchNameSalonhub: null,
        address: null,
        number: null,
        postalCode: null,
        city: null,
        province: null,
        country: null,
        phonenumber: null,
        email: null,
        ECsettings: {
          Sun: "19",
          Mon: "19",
          Tue: "19",
          Wed: "19",
          Thu: "19",
          Fri: "19",
          Sat: "19",
        },
        receiptData: {
          footer: null,
        },
        barometersSettings: {
          colourSaleTarget: null,
          ProductManipulateActive: false,
          Total4WeeksSaleManipulateActive: false,
          TreatmentManipulateActive: false,
          ProductManipulate: null,
          ProductSaleTarget: null,
          Total4WeeksSaleManipulate: null,
          Total4WeeksSaleTarget: null,
          TreatmentManipulate: null,
          TreatmentSaleTarget: null,
          revenuePerTicket: null,
        },
        drupalApiSettings: {
          basicAuth: false,
          url: null,
          basicAuthUsername: null,
          basicAuthPassword: null,
        },
      },
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      showNewDialog: false,
      feedback: null,
      errors: [],
      busy: false,
      surveySendTimes: [
        {
          name: "19:00u",
          value: "19",
        },
        {
          name: "21:00u",
          value: "21",
        },
      ],
    };
  },

  methods: {
    closeAddBranchDialog() {
      this.$emit("newBranchDialogChange", false);
      this.feedback = null;
    },

    addBranch() {
      if (this.$refs.AddBranchForm.validate()) {
        this.busy = true;
        let branchName = this.activeCompData.id + this.newBranch.name;
        let branchNameLower = branchName.toLowerCase();
        let branchNameLowerNoSpecial = branchNameLower.replace(
          /[!@#$%^&*+()"';:.,]+/g,
          "",
        );
        this.brancheId = branchNameLowerNoSpecial.replace(/\s+/g, "");

        let receiptBranchData = [
          "Salon",
          {
            style: "subheader",
            text: this.newBranch.address + " " + this.newBranch.number,
          },
          {
            style: "subheader",
            text: this.newBranch.phonenumber,
          },
          {
            style: "subheader",
            text: this.newBranch.email,
          },
          {
            style: "subheader",
            text: this.activeCompData.url,
          },
        ];

        db.collection("branches")
          .doc(this.brancheId)
          .set({
            compId: this.activeCompData.id,
            branchName: this.newBranch.name,
            branchNameSalonhub: this.newBranch.branchNameSalonhub,
            address: this.newBranch.address,
            number: this.newBranch.number,
            postalCode: this.newBranch.postalCode,
            city: this.newBranch.city,
            ECsettings: this.newBranch.ECsettings,
            province: this.newBranch.province,
            country: this.newBranch.country,
            phonenumber: this.newBranch.phonenumber,
            email: this.newBranch.email,
            barometersSettings: this.newBranch.barometersSettings,
            firstSurveyDate: null,
            receiptData: {
              branchData: receiptBranchData,
              footer: this.newBranch.receiptData.footer,
            },
            drupalApiSettings: {
              url: this.newBranch.drupalApiSettings.url,
              basicAuth: this.newBranch.drupalApiSettings.basicAuth,
              basicAuthUsername: this.newBranch.drupalApiSettings
                .basicAuthUsername,
              basicAuthPassword: this.newBranch.drupalApiSettings
                .basicAuthPassword,
            },
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action:
                  "Nieuwe vestiging toegevoegd: " + this.activeCompData.name,
                extra:
                  "<b>Naam vestiging:</b> " +
                  this.newBranch.name +
                  "<br>" +
                  "<b>Naam vestiging Salonhub:</b> " +
                  this.newBranch.branchNameSalonhub +
                  "<br>" +
                  "<b>Straat:</b> " +
                  this.newBranch.address +
                  "<br>" +
                  "<b>Huisnummer:</b> " +
                  this.newBranch.number +
                  "<br>" +
                  "<b>Postcode:</b> " +
                  this.newBranch.postalCode +
                  "<br>" +
                  "<b>Plaats:</b> " +
                  this.newBranch.city +
                  "<br>" +
                  "<b>Provincie:</b> " +
                  this.newBranch.province +
                  "<br>" +
                  "<b>Land:</b> " +
                  this.newBranch.country +
                  "<br><br>" +
                  "<b>Emotion Collect Verzendtijden:</b> " +
                  this.newBranch.ECsettings +
                  "<br><br>" +
                  "<b>Drupal API Settings:</b> " +
                  "<br>" +
                  "<b>Url:</b> " +
                  this.newBranch.drupalApiSettings.url +
                  "<br>" +
                  "<b>basicAuth:</b> " +
                  this.newBranch.drupalApiSettings.basicAuth +
                  "<br>" +
                  "<b>basicAuthUsername:</b> " +
                  this.newBranch.drupalApiSettings.basicAuthUsername +
                  "<br>" +
                  "<b>basicAuthPassword:</b> " +
                  this.newBranch.drupalApiSettings.basicAuthPassword,
              })
              .catch((error) => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeAddBranchDialog();
            this.$refs.AddBranchForm.reset();
            this.busy = false;
            console.log("Branch succesfully added");
          })
          .catch((error) => {
            this.busy = false;
            console.error("Error adding Branch: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Branch: " + this.activeCompName,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een vestiging toe te voegen.";
      }
    },
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
